<template>
    <svg class="feathericon">
        <use :xlink:href="url(`vendor/feathericons/feather-sprite.svg#${name}`)"/>
    </svg>
</template>

<script>
export default {
    props: ['name']
}
</script>
